"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _XUEEOXY3cjs = require('./XUEEOXY3.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/hovercard/hovercard-description.tsx
var TagName = "p";
var useHovercardDescription = _PTOCUU2Dcjs.createHook.call(void 0, function useHovercardDescription2(props) {
  props = _XUEEOXY3cjs.usePopoverDescription.call(void 0, props);
  return props;
});
var HovercardDescription = _PTOCUU2Dcjs.forwardRef.call(void 0, function HovercardDescription2(props) {
  const htmlProps = useHovercardDescription(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useHovercardDescription = useHovercardDescription; exports.HovercardDescription = HovercardDescription;
